import Filter from "@/components/kit/Filters/Filters";
import { useQueryParams } from "@/hooks/general/useQueryParams";
import { TUserParamsType } from "../../types";
const sortOptions = [
  { label: "Name", value: "NAME" },
  { label: "Email", value: "EMAIL" },
];

const UsersFilter = () => {
  const { params, setParams, deleteParam } = useQueryParams<TUserParamsType>({
    page: 1,
    limit: 25,
    orderBy: "NAME",
  });

  return (
    <div className="mt-2 px-6">
      <Filter<typeof params>
        onFiltersChange={(newFilters) => {
          setParams({ ...params, ...newFilters });
        }}
        values={params}
        onClearFilter={() => {
          deleteParam("orderBy");
          deleteParam("orderDirection");
        }}
      >
        <Filter.FilterSort
          label="sortBy"
          keyName={"orderBy"}
          options={sortOptions}
          dataToShow={
            sortOptions.find((option) => option.value === params.orderBy)?.label
          }
        />
      </Filter>
    </div>
  );
};
export default UsersFilter;
